function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import classNames from "classnames";
import PropTypes from "prop-types";
import React from "react";

var Checkbox = /*#__PURE__*/function (_React$Component) {
  _inherits(Checkbox, _React$Component);

  var _super = _createSuper(Checkbox);

  function Checkbox() {
    var _this;

    _classCallCheck(this, Checkbox);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));

    _defineProperty(_assertThisInitialized(_this), "getIsChecked", function () {
      return _this.input.checked;
    });

    _defineProperty(_assertThisInitialized(_this), "handleChange", function (evnt) {
      return typeof _this.props.onChange === "function" ? _this.props.onChange(_this.getIsChecked(), evnt) : undefined;
    });

    _defineProperty(_assertThisInitialized(_this), "handleClick", function (e) {
      // Need to stop the event from bubbling for situations
      // when the checkbox has a parent with an onclick (like advancedcombobox)
      if (e != null ? e.stopPropagation : undefined) {
        return e.stopPropagation();
      }
    });

    return _this;
  }

  _createClass(Checkbox, [{
    key: "render",
    value: function render() {
      var _this2 = this;

      var boxClassName = classNames({
        "et--checkbox--box": true,
        "is-partial": this.props.partial
      });
      return /*#__PURE__*/React.createElement("label", {
        className: classNames(this.props.className, "et--checkbox", {
          "is-disabled": this.props.disabled,
          "is-round": this.props.isRound
        })
      }, /*#__PURE__*/React.createElement("input", {
        ref: function ref(e) {
          return _this2.input = e;
        },
        type: "checkbox",
        className: "et--checkbox--input",
        checked: this.props.checked,
        defaultChecked: this.props.defaultChecked,
        name: this.props.name,
        value: this.props.value,
        disabled: this.props.disabled,
        onClick: this.handleClick,
        onChange: this.handleChange,
        tabIndex: "-1"
      }), /*#__PURE__*/React.createElement("span", {
        tabIndex: this.props.disabled ? undefined : 0,
        role: "checkbox",
        "aria-checked": this.props.checked,
        "aria-label": this.props.label ? "Select ".concat(this.props.label) : "Select checkbox",
        onKeyDown: function onKeyDown(e) {
          // on spacebar click
          if (e.key === " ") {
            _this2.input.click();
          }
        },
        className: boxClassName,
        style: this.props.checkboxStyle
      }), this.props.children);
    }
  }]);

  return Checkbox;
}(React.Component);

_defineProperty(Checkbox, "displayName", "Checkbox");

_defineProperty(Checkbox, "propTypes", {
  name: PropTypes.string,
  value: PropTypes.string,
  checked: PropTypes.bool,
  disabled: PropTypes.bool,
  partial: PropTypes.bool,
  checkboxStyle: PropTypes.object,
  onChange: PropTypes.func,
  children: PropTypes.any,
  defaultChecked: PropTypes.bool,
  label: PropTypes.string.isRequired,
  isRound: PropTypes.bool
});

export { Checkbox as default };